import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import { Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ConferenceCountriesMap from './ConferenceCountriesMap';

const conferenceCountryNames = [
  'Philippines',
  'Indonesia',
  'Chile',
  'United Kingdom',
  'Fiji',
  'Slovenia',
  'South Africa',
  'France',
  'Australia',
  'South Korea',
  'United States of America',
  'Canada',
  'Vietnam',
  'New Zealand',
  'Ethiopia',
  'Mexico',
  'Federated States of Micronesia',
  'Cambodia',
  'Thailand',
  'Taiwan',
  'Spain',
  'Iceland',
  'Japan'
];

const theme = createTheme({
  typography: {
    fontFamily: ['Radio Canada Big', 'Arial'].join(',')
  }
});

function ConferenceCountries() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        <ConferenceCountriesMap />
      </Box>
    </ThemeProvider>
  );
}

export default ConferenceCountries;
